// extracted by mini-css-extract-plugin
export default {"link":"oD-z","disabled":"pD-z"};